/**
 * TemplateConfiguracaoTemplate — visibilidade/classificação por indicador, filhos de Template.
 */
import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { RelatedEntityGrid } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import TemplateConfiguracao from '../../../models/TemplateConfiguracao';
import TemplateModel from '../../../models/Template';
import IndicadorEnum from '../../../enums/IndicadorEnum';

const model = {
  monitoramentotemplate: {
    exibir: 'main.template.configuracao.monitoramentotemplate',
    visivel: true,
    tipo: 'relacao',
    camporelacao: 'descricao',
    entidade: 'monitoramentotemplate.entidade',
    template: 'monitoramentotemplate.template',
    validacao: { obrigatorio: true },
  },
  campo: { exibir: 'main.template.configuracao.campo', visivel: true, tipo: 'enum', entidade: 'indicador', validacao: { obrigatorio: true } },
  visivel: { exibir: 'main.template.configuracao.visivel', tipo: 'boolean' },
  template: { exibir: 'main.template.configuracao.template' },
};

const renderers = {
  'monitoramentotemplate.entidade': TemplateModel,
  'monitoramentotemplate.template': (rowData) => rowData.monitoramentotemplate?.descricao || '',
  indicador: IndicadorEnum,
};

class TemplateConfiguracaoFormulario extends Component {
  render() {
    const { model, contexto } = this.props;
    return (
      <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
        <TabPanel header={UtilService.traduzir('main.template.configuracao.aba.informacoesbasicas')} leftIcon="pi pi-info-circle mr-2">
          <div className="grid w-full">
            <div className="field col-12 mt-3"><ModelDropDown model={model.monitoramentotemplate} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelDropDown model={model.campo} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelBoolean model={model.visivel} contexto={contexto} /></div>
            <div className="field col-12 mt-3"><ModelTextInput model={model.template} contexto={contexto} /></div>
          </div>
        </TabPanel>
      </TabViewComErro>
    );
  }
}

class TemplateConfiguracaoTemplate extends Component {
  render() {
    return (
      <RelatedEntityGrid
        entidade={TemplateConfiguracao}
        model={model}
        identidade="main.template.configuracao"
        icone="pi-eye"
        permissoes={this.props.permissoes}
        storageKey="dt-templateconfiguracoes"
        processos={[]}
        relacionados={[]}
        renderers={renderers}
        configuracao={this.props.configuracao}
        formulario={(m, ctx) => <TemplateConfiguracaoFormulario model={m} contexto={ctx} />}
      />
    );
  }
}

export default TemplateConfiguracaoTemplate;
